import React, { useState, useCallback } from "react"
import { Drawer } from "antd"
import { ProcedureForm } from "~/components"
import useProjectContext from "./useProjectContext"

const useProcedure = ({
  procedure,
  loading = false,
  width = "60%",
  onClose,
  onSubmit,
  onRemove,
} = {}) => {
  const [visible, setVisible] = useState(false)
  const show = () => setVisible(true)
  const hide = () => setVisible(false)
  const onCancel = () => {
    onClose && onClose()
    hide()
  }
  const { activeProject } = useProjectContext()

  const ProcedureDrawer = useCallback(() => {
    return (
      <Drawer
        width={width}
        closeIcon={null}
        keyboard={false}
        title={"Quy trình"}
        open={visible}
        onClose={onCancel}
      >
        <ProcedureForm
          id={procedure?.id}
          initialValues={{
            ...procedure,
            project:
              procedure?.project ||
              (activeProject && {
                label: activeProject?.label,
                value: activeProject?.value,
              }),
          }}
          onSubmit={onSubmit}
          onRemove={onRemove}
          onCancel={onCancel}
          loading={loading}
        />
      </Drawer>
    )
    // eslint-disable-next-line
  }, [visible])

  return {
    visible,
    show,
    hide,
    ProcedureDrawer,
  }
}

export default useProcedure
